import { render } from "./OrderOnline.vue?vue&type=template&id=4cae52ff"
import script from "./OrderOnline.vue?vue&type=script&lang=js"
export * from "./OrderOnline.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "/home/adminhost/web/crevent.waroengss.id/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__